module.exports = __webpack_public_path__ + "static/flags/TO-55c0071bc5076a03bcbfd08ff7bed3cd.gif";